// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RemoveButton{align-items:center;background:transparent;border:0;color:#6c757d;cursor:pointer;display:flex;padding:0;transition:color .25s ease-in-out}.RemoveButton:focus,.RemoveButton:hover{color:#161616;outline:0}.RemoveButton>svg{color:#6c757d;height:1em;transition:color .25s ease-in-out;width:1em}.RemoveButton:focus>svg,.RemoveButton:hover>svg{color:#161616}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
